var path = '/common/formly/inputs/tpl/html-checkbox.html';
var html = "<div class=checkbox> <label> <input type=checkbox class=formly-field-checkbox ng-model=model[options.key]> <span dynamic-bind-html={{to.label}}></span>{{to.required ? '*' : ''}} </label> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/common/formly/inputs/tpl/html-checkbox.html
// module id = 448
// module chunks = 1 3